<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Charleyna East is an English Teacher, who loves to write when she is not reaching the minds of students. She has a Bachelors and Master’s in Education. With a background in creative writing and a love for describing things in detail, she enjoys writing poetry, informational articles and fictional tales that tell a story or prod the mind. Although she lives in the small town of Prattville, Alabama, she loves to take her readers on journeys to other worlds.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?d06e75b6